import { findNode, focusEditor, moveNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamEditor } from '../../../types';
import { DragItem } from '../../../plugins/dnd/types';

export const insertItemIntoContainer = (
  editor: DreamEditor,
  at: Path,
  item: DragItem,
) => {
  const dragEntry = findNode(editor, {
    at: [],
    match: (node) => node.id === item.id,
  });
  if (!dragEntry) return;

  const [, dragPath] = dragEntry;

  const dropPath = at;

  moveNodes(editor, {
    at: dragPath,
    to: [...dropPath, 0],
  });

  focusEditor(editor);
};
